import React, { useState } from 'react';
import './practiceapp.css';

const invoices = [
  {
    id: 1,
    title: 'Factura 001',
    supplier: 'SC Alfa SRL',
    client: 'SC ContaLearn SRL',
    invoiceNumber: 'F001',
    date: '2026-06-12',
    displayDate: '12.06.2026',
    total: '1500',
    displayTotal: '1.500 lei',
    debitAccount: '371',
    creditAccount: '401',
  },
  {
    id: 2,
    title: 'Factura 002',
    supplier: 'SC Beta SRL',
    client: 'SC ContaLearn SRL',
    invoiceNumber: 'F002',
    date: '2026-06-15',
    displayDate: '15.06.2026',
    total: '2000',
    displayTotal: '2.000 lei',
    debitAccount: '3028',
    creditAccount: '401',
  },
];

const initialAnswers = {
  date: '',
  invoiceNumber: '',
  debitAccount: '',
  creditAccount: '',
  amount: '',
};

const PracticeApp = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [answers, setAnswers] = useState(initialAnswers);
  const [checked, setChecked] = useState(false);

  const currentInvoice = invoices[currentIndex];

  const handleChange = (field, value) => {
    setAnswers((prev) => ({
      ...prev,
      [field]: value,
    }));
    setChecked(false);
  };

  const isCorrect = (field) => {
    return (
      answers[field].trim().toLowerCase() ===
      String(currentInvoice[field]).toLowerCase()
    );
  };

  const resetAnswers = () => {
    setAnswers(initialAnswers);
    setChecked(false);
  };

  const handleNext = () => {
    setCurrentIndex((prev) => Math.min(prev + 1, invoices.length - 1));
    resetAnswers();
  };

  const handleBack = () => {
    setCurrentIndex((prev) => Math.max(prev - 1, 0));
    resetAnswers();
  };

  return (
    <div className="practice-app-page">
      <div className="practice-tabs">
        <button className="practice-tab active">Facturi</button>
        <button className="practice-tab">Chitante</button>
        <button className="practice-tab">Extrase</button>
        <button className="practice-tab">Note contabile</button>
      </div>

      <div className="practice-layout">
        <div className="invoice-panel">
          <div className="invoice-paper">
            <div className="invoice-header">
              <h2>FACTURA</h2>
              <span>{currentInvoice.invoiceNumber}</span>
            </div>

            <div className="invoice-info">
              <p><b>Furnizor:</b> {currentInvoice.supplier}</p>
              <p><b>Client:</b> {currentInvoice.client}</p>
              <p><b>Data:</b> {currentInvoice.displayDate}</p>
            </div>

            <table className="invoice-table">
              <thead>
                <tr>
                  <th>Produs</th>
                  <th>Cant.</th>
                  <th>Pret</th>
                  <th>Total</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Marfa</td>
                  <td>1</td>
                  <td>{currentInvoice.displayTotal}</td>
                  <td>{currentInvoice.displayTotal}</td>
                </tr>
              </tbody>
            </table>

            <div className="invoice-total">
              Total: {currentInvoice.displayTotal}
            </div>
          </div>
        </div>

        <div className="answers-panel">
          <label>
            Data
            <input
              type="date"
              value={answers.date}
              onChange={(e) => handleChange('date', e.target.value)}
              className={checked ? (isCorrect('date') ? 'correct' : 'wrong') : ''}
            />
          </label>

          <label>
            Nr. document
            <input
              type="text"
              value={answers.invoiceNumber}
              onChange={(e) => handleChange('invoiceNumber', e.target.value)}
              className={checked ? (isCorrect('invoiceNumber') ? 'correct' : 'wrong') : ''}
              placeholder="ex: F001"
            />
          </label>

          <div className="accounts-row">
            <label>
              Cont debit
              <input
                type="text"
                value={answers.debitAccount}
                onChange={(e) => handleChange('debitAccount', e.target.value)}
                className={checked ? (isCorrect('debitAccount') ? 'correct' : 'wrong') : ''}
                placeholder="ex: 371"
              />
            </label>

            <label>
              Cont credit
              <input
                type="text"
                value={answers.creditAccount}
                onChange={(e) => handleChange('creditAccount', e.target.value)}
                className={checked ? (isCorrect('creditAccount') ? 'correct' : 'wrong') : ''}
                placeholder="ex: 401"
              />
            </label>

            <label>
              Suma
              <input
                type="text"
                value={answers.amount}
                onChange={(e) => handleChange('amount', e.target.value)}
                className={checked ? (isCorrect('amount') ? 'correct' : 'wrong') : ''}
                placeholder="ex: 1500"
              />
            </label>
          </div>

          <button className="verify-btn" onClick={() => setChecked(true)}>
            Verifica
          </button>

          <div className="navigation-buttons">
            <button onClick={handleBack} disabled={currentIndex === 0}>
              Inapoi
            </button>

            <span>{currentIndex + 1} / {invoices.length}</span>

            <button onClick={handleNext} disabled={currentIndex === invoices.length - 1}>
              Inainte
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PracticeApp;